module.exports = __webpack_public_path__ + "img/slider.f8c449f.jpg";